import * as React from "react";
import { SVGProps } from "react";

export const ArrowRight = (
  props: SVGProps<SVGSVGElement> & {
    width?: number;
    height?: number;
    color?: string;
  }
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 41}
    height={props.height || 40}
    viewBox="0 0 41 40"
    fill="none"
    {...props}
  >
    <path
      fill={props.color || "#A3A3A6"}
      d="m16.697 10.058-2.336 2.336L21.95 20l-7.59 7.606 2.337 2.336L26.639 20l-9.942-9.942Z"
    />
  </svg>
);
